import { render, staticRenderFns } from "./EditAmlCommentModal.vue?vue&type=template&id=2720b2ee"
import script from "./EditAmlCommentModal.vue?vue&type=script&lang=js"
export * from "./EditAmlCommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports